// Mood Board Color
export const BG_PRIMARY = 'rgba(254,250,244,1)';
export const BG_SECONDARY = 'rgba(165,143,121,1)';
export const BG_ALTERNATIVE = 'rgba(165,143,121,1)';
export const BG_OPACITY = '#323030';

export const ASSETS_PRIMARY = 'rgba(165,143,121,1)';
// Text Color
export const TEXT_PRIMARY = '#2C3F4E';
export const TEXT_SECONDARY = 'rgba(44,63,78,1)';
export const TEXT_ALTERNATIVE = '#FEFEFE';

// Music & Navigation Color
export const NAVIGATION_COLOR = 'rgba(44,63,78,1)'; // Warna BG
export const ICON_NAVIGATION_COLOR = 'white'; // Warna Iconnya
